<template>
  <div class="mobile-layout">
    <div class="mobile-header mobile-container"><mobile-header /></div>
    <div class="mobile-nav">
      <mobile-nav />
    </div>
    <div class="mobile-main">
      <slot></slot>
    </div>
    <div class="mobile-footer">
      <div class="mobile-container"><mobile-footer /></div>
    </div>
  </div>
</template>
<script>
import MobileNav from "./MobileNav.vue";
import MobileHeader from "./MobileHeader.vue";
import MobileFooter from "./MobileFooter.vue";
export default {
  components: {
    MobileNav,
    MobileFooter,
    MobileHeader,
  },
  beforeCreate() {
    import("amfe-flexible");
  },
};
</script>
<style lang="scss" scoped>
html {
  font-size: 14px;
}

.mobile-layout {
  .mobile-header {
    height: 230px;
  }

  .mobile-nav {
    height: 200px;
    background-color: white;
  }

  .mobile-main {
    min-height: calc(100vh - 570px); // 450px=header+nav+footer
    background: #f2f6ff;
  }

  .mobile-footer {
    height: 140px;
    background-color: #000;
  }
}
</style>
